import React, { useState, useEffect, useRef } from 'react';
import { Typography, TextField } from '@mui/material';
import { toast as Toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import { FormControl, InputAdornment, OutlinedInput } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import SendIcon from "@mui/icons-material/Send";
import { emptyIfNull } from "../../utils/methods.utils";
import firebase from 'firebase';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from "@mui/styles/";
const useStyles = makeStyles({
    headerLeft: {
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 10,
        paddingRight: 10,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    userProfileImage: { height: '100%', aspectRatio: 1, borderRadius: 100 },
    container: {
        flex: 1,
        backgroundColor: '#fff',
    },
    messageInputView: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        marginBottom: 20,
        paddingLeft: 14,
        right: 0,
        left: 0,
        width: "100%",
        paddingRight: 14,
        backgroundColor: '#fff',
        borderRadius: 4,

        height: 'fit-content',
        borderWidth: 1,
        paddingBlock: 10,
        //alignSelf: "center"

    },
    messageInput: {
        height: 40,
        flex: 1,
        paddingLeft: 10,
        paddingRight: 10,
        marginBottom: 10
    },
    messageSendView: {
        paddingLeft: 25,
        paddingRight: 25,
        paddingBlock: 10,
        cursor: "pointer",
        justifyContent: 'center',

        alignSelf: "center"
    },
    mainContainer: {
        paddingTop: 10,
    },
});

export default function CustomerSupportScreen({ navigation }) {
    // const { userInfo, user } = useAuthentication();
    const [messages, setMessages] = useState([]);
    const [inputMessage, setInputMessage] = useState('');
    const [isSending, setIsSending] = useState(false);
    const [loading, setLoading] = useState(true);
    const styles = useStyles();
    const adminMsgsCounter = useRef(0);
    const customTheme = useTheme();
    const userInfo = useSelector((state) => state.auth.user);
    const container = useRef();
    function getTime(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }
    useEffect(() => {

        (async () => {
            const chat = await firebase
                .firestore()
                .collection("support-messages")
                .doc(userInfo?.id).get();
            if (chat.exists) {
                const counter = chat.data();
                if (!!counter.adminUnreadCounter) {
                    adminMsgsCounter.current = counter.adminUnreadCounter;
                }
                await firebase
                .firestore()
                .collection("support-messages")
                .doc(userInfo?.id).set({
                    ...chat.data(),
                    userUnreadCounter:0,
                },{merge:true})
                
            }
        })()
        const handleMessages = firebase
            .firestore()
            .collection("support-messages")
            .doc(userInfo?.id)
            .collection("messages").orderBy("createdAt", "asc")
            .onSnapshot((querySnapshot) => {
                setLoading(true);
                let msgsData = [];
                querySnapshot.forEach(doc => {
                    const t = getTime(doc.data().createdAt.toDate());
                    msgsData.push({ ...doc.data(), time: t });
                });
                console.log("msgs : ", msgsData)
                setMessages(msgsData);
                setLoading(false);
            });
        return handleMessages;
    }, [userInfo])
    useEffect(() => {
        if (container.current) {
            console.log("eee : ", container.current);
            container.current?.scrollIntoView({ block: "end", behavior: 'smooth' });;
        }
    }, [messages, container.current])


    const sendMessage = async () => {
        setIsSending(true);
        if (inputMessage === '') {
            setIsSending(false);
            return setInputMessage('');
        }
        try {
            let messageData = {};
            let lastMessage = {
                id: "",
                uid: userInfo?.id,
                senderName: userInfo?.fullName,
                message: inputMessage,
                createdAt: new Date(),
                isAdmin: false
            }
            if (!messages || messages.length === 0) {
                messageData["createdAt"] = new Date();
                messageData["didAdminRespond"] = false;
            } else {
                messageData["updatedAt"] = new Date();
            }
            setInputMessage('');
            const msgRef = firebase.firestore().collection("support-messages").doc(userInfo?.id).collection("messages").doc();
            lastMessage.id = msgRef.id;
            await msgRef.set({ ...lastMessage }, { merge: true });
            await firebase.firestore().collection("support-messages").doc(userInfo.id).set({
                ...messageData,
                lastMessage: lastMessage,
                adminUnreadCounter: adminMsgsCounter.current + 1,
                userInfo: {
                    uid: userInfo?.id,
                    fullName: userInfo?.fullName,
                    profileImage: userInfo?.profileImage ?? ""
                }
            }, { merge: true });
            adminMsgsCounter.current = adminMsgsCounter.current + 1;
            const t = getTime(lastMessage.createdAt);
            setMessages([...messages, { ...lastMessage, time: t }])
            if (!messages || messages.length <= 0) {
                Toast.success('Our support team will respond to you as soon as possible');
            }

            setIsSending(false);
        } catch (err) {
            console.log("Error sending msg : ", err);
            Toast.error("Failed to send message, please try agian later")
            setInputMessage('');
            setIsSending(false);
        }
    }

    return (

        !loading ?
            <div ref={container}>
                <div style={{ flex: 1, backgroundColor: customTheme.light.white, paddingBlock: 20, paddingInline: 20 }}>
                    <div className={styles.container} style={{ height: "100%", flexDirection: "row", justifyContent: "center", alignContent: "center", backgroundColor: '#fff', paddingBottom: 20 }}>
                        <div style={{ height: "100%" }}>
                            {messages.map((item, index) => {
                                return (<div key={"chat msg touchable " + index} style={{ display: "flex", justifyContent: !!item.isAdmin ? "flex-start" : "flex-end" }}  >
                                    <div style={{ marginTop: 6, width: "fit-content", display: "flex", flexDirection: "row" }} key={"chat msg view1 " + item.id}>
                                        <div
                                            key={"chat msg view2 " + item.id}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                backgroundColor: !!item.isAdmin ? customTheme.light.primary : customTheme.light.dark,
                                                alignSelf: !!item.isAdmin ? 'flex-start' : 'flex-end',
                                                marginHorizontal: 10,
                                                padding: 10,
                                                borderRadius: 8,
                                                borderBottomLeftRadius: !!item.isAdmin ? 0 : 8,
                                                borderBottomRightRadius: !!item.isAdmin ? 8 : 0,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    color: !!item.isAdmin ? "black" : '#fff',
                                                    fontSize: 16,
                                                }}
                                            >
                                                {item.message}
                                            </div>
                                            <div
                                                style={{
                                                    color: !!item.isAdmin ? "GrayText" : '#fff',
                                                    fontSize: 14,
                                                    alignSelf: 'flex-end',
                                                }}
                                            >
                                                {item.time}
                                            </div>
                                        </div>
                                    </div>
                                </div>);
                            })}
                        </div>
                    </div>
                </div>
                <div className={styles.messageInputView} style={{ flexDirection: "row" }} >
                    <FormControl sx={{ display: { xs: "none", md: "flex" } }} style={{ flex: 1 }} variant="outlined">
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type={'text'}
                            value={inputMessage}
                            onChange={(value) => setInputMessage(emptyIfNull(value.target.value))}
                            placeholder={"Message"}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="Clear"
                                        onClick={() => {
                                            if (!isSending && !!userInfo?.id)
                                                sendMessage();
                                        }}
                                        edge="end"
                                    >
                                        <SendIcon style={{ color: "#fac904" }} />
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </FormControl>

                </div>
            </div> : <></>
    );
}
